import { render, staticRenderFns } from "./ComisionDelete.vue?vue&type=template&id=c756bd7e"
import script from "./ComisionDelete.vue?vue&type=script&lang=js"
export * from "./ComisionDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports